import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { tunnelSelectors, userSelectors } from 'reducers';
import { isStatusOk, parseFullName } from 'utils/helpers';
import { texts } from 'utils/languages/fr';

import { TunnelStep } from 'containers/tunnel/common';
import ContactInfoPage from './ContactInfoPage';
import SMSCodePage from './SMSCodePage';
import { stepIDs } from 'utils/constants';

const ContactInfo = props => {
    const { handleNextStep, userStep } = props;

    const { stepId } = useParams();

    const internalUser = useSelector(userSelectors.getInternalUser);
    const showCodeVerifier = useSelector(tunnelSelectors.getShowCodeVerifier);
    const tunnelSubscription = useSelector(userSelectors.getTunnelSubscription);

    const isResubmit = useMemo(
        () => !!userStep || !!tunnelSubscription.createdBy,
        [userStep, tunnelSubscription]
    );
    const hasStatusOk = useMemo(() => isStatusOk(userStep), [userStep]);

    const isStepVerified = useMemo(() => userStep?.successfulAttemptsNumber > 0, [userStep]);

    return (
        <TunnelStep
            title={
                showCodeVerifier && !tunnelSubscription.indirectUntransferred
                    ? texts.COORDONNEES_CODE_SMS
                    : +stepId === stepIDs.CO_SUBSCRIBER_CONTACT_INFO
                    ? texts.CO_SUBSCRIBER_CONTACT_INFO
                    : `${texts.BIENVENUE} ${parseFullName(internalUser)},`
            }
            subtitle={texts.AFIN_DE_MIEUX}
        >
            {showCodeVerifier ? (
                <SMSCodePage handleNextStep={handleNextStep} />
            ) : (
                <ContactInfoPage
                    isResubmit={isResubmit}
                    hasStatusOk={hasStatusOk}
                    isStepVerified={isStepVerified}
                    isPhoneVerified={userStep?.successfulAttemptsNumber > 0}
                    handleNextStep={handleNextStep}
                />
            )}
        </TunnelStep>
    );
};

export default ContactInfo;
